import { Dropdown } from 'primereact/dropdown';
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { selectLayerGroup, } from '../../features/layerSlice';
import { setSelectedParcelRapor } from '../../features/sharedSlice';
import { useAppSelector } from '../../store/hooks';
import Table from '../table/Table'

export default function ParselRapor() {
  const dispatch = useDispatch();
  const layerGroups = useAppSelector(selectLayerGroup)
  const [parcelLayer, setParcelLayer] = useState<any>(null)
  const [changedSelectedCategory, setChangedSelectedCategory] = useState<any>({ name: 'Tümü', key: 'A' })
  const categories = [
    { name: 'Tümü', key: 'A' },
    { name: 'Proje Aşamasında', key: 'B' },
    { name: 'Proje Süresi Geçenler', key: 'C' },
    { name: 'Proje Uzatma Süresi Alanlar', key: 'D' },
    { name: 'İnşaat Aşamasında', key: 'E' },
    { name: 'İnşaat Süresi Geçenler', key: 'F' },
    { name: 'İnşaat Uzatma Süresi Alanlar', key: 'G' },
    { name: 'Üretim Aşamasında', key: 'H' }]

  useEffect(() => {
    if (layerGroups.length < 0) {
      return;
    }
    const parselLayer = layerGroups.find(layerGroup => layerGroup.name === 'parsel')?.layers.find(layer => layer.name === 'parsel_usr');
    setParcelLayer(parselLayer);
  }, [layerGroups])

  return (
    <div>
      <div className='rapor-column'>
        <Dropdown options={categories} value={changedSelectedCategory} optionLabel='name' placeholder='İl Seçiniz' style={{ width: '200px' }}
          onChange={(e) => { setChangedSelectedCategory(e.value); dispatch(setSelectedParcelRapor(e.value)) }} />
      </div>
      {parcelLayer && <Table layer={parcelLayer} raporTable={true} />}
    </div>
  )
}
